<form [formGroup]="employeeForm" (ngSubmit)="saveEmployee(inProgress)">
  <div class=" modal-header">
    <h5 class="modal-title d-flex align-items-center">
      <i class="ri-group-line me-1 font-20 text-primary"></i>{{ !u?.value?.id? 'Add' : 'Update'}} Employee
    </h5>
    <button type="button" class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close"
      (click)="activeModal.close('Close')"></button>
  </div>
  <div class="modal-body">
    <div class="row g-3" formGroupName="employeeData">
      <div class="col-md-3">
        <label for="name" class="form-label">Name <b class="text-secondary">*</b></label>
        <div class="input-group">
          <select class="form-select emp-selection" formControlName="title" [ngClass]="{'is-invalid': submitted && u.controls.title.errors}">
            <option *ngFor="let surname of surnames" [ngValue]="surname">{{surname}}</option>
          </select>
          <input type="text" class="form-control ps-1" id="name" placeholder="Enter Name"
            [ngClass]="{'is-invalid': submitted && u.controls.name.errors}" formControlName="name" ngbAutofocus
            autocomplete="off" />
          <div class="invalid-feedback" *ngIf="submitted && u.controls.name.errors">
            <span *ngIf="u.controls.name.errors.required">Please provide a valid name.</span>
            <span *ngIf="u.controls.name.errors.pattern">Please provide a valid name.</span>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <label for="surname" class="form-label">Surname <b class="text-secondary">*</b></label>
        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0">
            <i class='bx bx-user-plus'></i>
          </span>
          <input type="text" class="form-control ps-1" id="surname" placeholder="Enter Surname"
            [ngClass]="{'is-invalid': submitted && u.controls.surname.errors}" formControlName="surname"
            autocomplete="off" />
          <div class="invalid-feedback" *ngIf="submitted && u.controls.surname.errors">
            <span *ngIf="u.controls.surname.errors.required">Please provide a valid surname.</span>
            <span *ngIf="u.controls.surname.errors.pattern">Please provide a valid surname.</span>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <label for="gender" class="form-label">Gender <b class="text-secondary">*</b></label>
        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-body'></i></span>
          <ng-select class="form-control rcx-ng-select" formControlName="gender" placeholder="Select a Gender"
            [ngClass]="{'is-invalid': submitted && u.controls.gender.errors}" [clearable]="false">
            <ng-option *ngFor=" let gender of genders;" [value]="gender">{{gender}}</ng-option>
          </ng-select>
          <div class="invalid-feedback" *ngIf="submitted && u.controls.gender?.errors">
            <span *ngIf="u.controls.gender.errors.required">Please select a Gender</span>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <label for="code" class="form-label">Code</label>
        <div class="input-group"> <span class="input-group-text bg-transparent border-end-0">
            <i class='bx bx-code-block'></i></span>
          <input type="text" class="form-control ps-1" id="code" placeholder="Code" readonly
          [ngClass]="{'is-invalid': submitted && u.controls.code.errors}" formControlName="code" autocomplete="off" />
          <div class="invalid-feedback" *ngIf="submitted && u.controls.code.errors">
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <label for="dob" class="form-label">Date Of Birth <b class="text-secondary">*</b></label>
        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0">
            <i class='bx bx-calendar'></i>
          </span>
          <input type="date" class="form-control ps-1" id="dob" formControlName="dob"
            [ngClass]="{'is-invalid': submitted && u.controls.dob.errors}" />
          <div class="invalid-feedback" *ngIf="submitted && u.controls.dob.errors">
            <span *ngIf="u.controls.dob.errors.required">Please provide a valid date of birth.</span>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <label for="doj" class="form-label">Date Of Joining <b class="text-secondary">*</b></label>
        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0">
            <i class='bx bx-calendar'></i>
          </span>
          <input type="date" class="form-control ps-1" id="doj" formControlName="doj"
            [ngClass]="{'is-invalid': submitted && u.controls.doj.errors}" />
          <div class="invalid-feedback" *ngIf="submitted && u.controls.doj.errors">
            <span *ngIf="u.controls.doj.errors.required">Please provide a valid date of joining.</span>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <label for="report" class="form-label">Reported To</label>
        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-repost'></i></span>
          <ng-select class="form-control rcx-ng-select" formControlName="reportTo" placeholder="Select a Reported To"
            [ngClass]="{'is-invalid': submitted && u.controls.id.errors}">
            <ng-option *ngFor="let reportTo of reports" [value]="reportTo?.employeeData?.id">
              {{ reportTo?.employeeData?.name }}
            </ng-option>
          </ng-select>
          <div class="invalid-feedback" *ngIf="submitted && u.controls.id.errors">
            <span *ngIf="u.controls.id.errors.required">Please select a Reported To</span>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <label for="report" class="form-label">Address To</label>
        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-repost'></i></span>
          <ng-select class="form-control rcx-ng-select" formControlName="addressTo" placeholder="Select a Addresse To"
            [ngClass]="{'is-invalid': submitted && u.controls.id.errors}">
            <ng-option *ngFor="let addressTo of reports" [value]="addressTo?.employeeData?.id">
              {{ addressTo?.employeeData?.name }}
            </ng-option>
          </ng-select>
          <div class="invalid-feedback" *ngIf="submitted && u.controls.id.errors">
            <span *ngIf="u.controls.id.errors.required">Please select a Addresse To</span>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <label for="blood" class="form-label">Blood Group <b class="text-secondary">*</b></label>
        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0"><i class='bx bxs-donate-blood'></i></span>
          <ng-select class="form-control rcx-ng-select" formControlName="blood" placeholder="Select Blood Group"
            [ngClass]="{'is-invalid': submitted && u.controls.blood.errors}" [clearable]="false">
            <ng-option *ngFor="let blood of bloods;" [value]="blood">{{blood}}</ng-option>
          </ng-select>
          <div class="invalid-feedback" *ngIf="submitted && u.controls.blood.errors">
            <span *ngIf="u.controls.blood.errors.required">Please select a blood group.</span>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <label for="email" class="form-label">Email <b class="text-secondary">*</b></label>
        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-envelope'></i></span>
          <input type="text" class="form-control ps-1" id="email" placeholder="Enter your email"
            [ngClass]="{'is-invalid': submitted && u.controls.email.errors}" formControlName="email"
            autocomplete="off" />
          <div class="invalid-feedback" *ngIf="submitted && u.controls.email.errors">
            <span *ngIf="u.controls.email.errors.required">Please provide an email.</span>
            <span *ngIf="u.controls.email.errors.pattern">Please provide a valid email address.</span>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <label for="aadhaar" class="form-label">Aadhar Number <b class="text-secondary">*</b></label>
        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-barcode-reader'></i></span>
          <input type="text" class="form-control ps-1" id="aadhaar" placeholder="Enter Aadhar No"
            [ngClass]="{'is-invalid': submitted && u.controls.aadhaar.errors}" formControlName="aadhaar"
            autocomplete="off" [attr.value]="employeeForm.value.aadhaar | uppercase" />
          <div class="invalid-feedback" *ngIf="submitted && u.controls.aadhaar.errors">
            <span *ngIf="u.controls.aadhaar.errors.required || u.controls.aadhaar.errors.pattern">Please provide a valid
              Aadhar Number.</span>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <label for="pan" class="form-label">PAN</label>
        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-barcode-reader'></i></span>
          <input type="text" class="form-control ps-1" id="pan" placeholder="Enter PAN number"
            [ngClass]="{'is-invalid': submitted && u.controls.pan.errors}" formControlName="pan" autocomplete="off"
            [attr.value]="employeeForm.value.pan | uppercase" />
          <div class="invalid-feedback" *ngIf="submitted && u.controls.pan && u.controls.pan.errors">
            <span *ngIf="u.controls.pan.errors.required">Please provide a valid PAN Number.</span>
            <span *ngIf="u.controls.pan.errors.pattern">Please provide a valid PAN Number.</span>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <label for="Logo" class="form-label">Avatar</label>
        <div class="input-group">
          <input type="file" class="custom-file-input form-control" id="upload" (change)="getAndSetBase64($event)"
            accept=".jpg,.jpeg,.png" formControlName="avatar">
        </div>
      </div>
      <div class="col-md-auto">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="salaried" formControlName="salaried">
          <label class="form-check-label" for="salaried">Salaried</label>
        </div>
      </div>
      <div class="col-md-auto">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="employeeDisabled" formControlName="disabled">
          <label class="form-check-label" for="employeeDisabled">Inactive</label>
        </div>
      </div>
    </div>
  </div>
  <div class=" modal-header">
    <h5 class="modal-title d-flex align-items-center">
      <i class="bx bx-user me-1 font-20 text-primary"></i>{{ !a?.value?.id? 'Add' : 'Update'}} User
    </h5>
  </div>
  <div class="modal-body" formGroupName="userData">
    <div class="row g-3">
      <div class="col-md-4">
        <label for="username" class="form-label">Username <b class="text-secondary">*</b></label>
        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-user-plus'></i></span>
          <input type="text" class="form-control ps-1" id="username" placeholder="Enter a valid email"
            [ngClass]="{'is-invalid': submitted && a.controls.username.errors}" formControlName="username"
            autocomplete="off" />
          <div class="invalid-feedback" *ngIf="submitted && a.controls.username.errors">
            <span *ngIf="a.controls.username.errors.required">Please provide a valid username.</span>
            <span *ngIf="a.controls.username.errors.pattern">Please provide a valid email.</span>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <label for="role" class="form-label">Role <b class="text-secondary">*</b></label>
        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0"><i class='bx bxs-grid-alt'></i></span>
          <ng-select class="form-control rcx-ng-select" formControlName="roleId" placeholder="Select Role"
            [ngClass]="{'is-invalid': submitted && a.controls.roleId.errors}" [clearable]="false">
            <ng-option *ngFor="let role of roles;" [value]="role.id">{{role.name}}</ng-option>
          </ng-select>
          <div class="invalid-feedback" *ngIf="submitted && a.controls.roleId.errors">
            <span *ngIf="a.controls.roleId.errors.required">Please select a role.</span>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <label for="password" class="form-label">Password <b class="text-secondary">*</b></label>
        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-lock'></i></span>
          <input type="password" class="form-control ps-1" id="password" placeholder="Enter password" #password
            [ngClass]="{'is-invalid': submitted && a.controls.password?.errors}" formControlName="password"
            autocomplete="off" (copy)="$event.preventDefault()" (cut)="$event.preventDefault()"
            (paste)="$event.preventDefault()" />
          <span class="symbol-eye" *ngIf="!(submitted && a.controls.password?.errors)">
            <i [class]="password.type==='password'? 'bx bx-low-vision':'bx bx-show'"
              (click)="showPassword(password)"></i>
          </span>
          <div class="invalid-feedback" *ngIf="submitted && a.controls.password.errors">
            <span *ngIf="a.controls.password.errors.required">Please provide a valid password.</span>
            <span *ngIf="a.controls.password.errors.pattern">Try a mix of letters, numbers, and symbols</span>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <label for="confirm" class="form-label">Confirm Password<b class="text-secondary">*</b></label>
        <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
              class='bx bx-lock'></i></span>
          <input type="password" class="form-control ps-1" id="confirm" placeholder="Enter confirm Password" #confirm
            [required]="a.controls?.password?.value "
            [ngClass]="{'is-invalid': submitted && (a.controls.confirm?.errors || a.controls?.confirm.value!=a.controls?.password?.value)}"
            formControlName="confirm" autocomplete="off" (copy)="$event.preventDefault()"
            (cut)="$event.preventDefault()" (paste)="$event.preventDefault()" />
          <span class="symbol-eye"
            *ngIf="!(submitted && a.controls.confirm?.errors || (a.controls.confirm?.value !== a.controls.password?.value))">
            <i [class]="confirm.type==='password' ? 'bx bx-low-vision' : 'bx bx-show'"
              (click)="showPassword(confirm)"></i>
          </span>
          <div class="invalid-feedback"
            *ngIf="submitted && (a.controls.confirm?.errors ||( a.controls?.confirm?.value!== a.controls?.password?.value))">
            <span *ngIf="a.controls.confirm.errors?.required">Please confirm your password.</span>
            <span *ngIf="a.controls.confirm.errors?.pattern">Try a mix of letters, numbers, and symbols</span>
            <span
              *ngIf="!a.controls.confirm.errors && a?.controls.confirm?.value !== a.controls?.password?.value">Password
              and confirm
              password don't match</span>
          </div>
        </div>
      </div>
      <div class="col-md-auto">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="verified" formControlName="verified">
          <label class="form-check-label" for="verified">Verified</label>
        </div>
      </div>
      <div class="col-lg-auto ms-auto">
        <button type="submit" class="btn btn-secondary rcx-btn" #inProgress
          [ngClass]="{'no-event':inProgress?.value=='true'}">
          <ng-container *ngIf="inProgress?.value=='true'">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            {{u?.value?.id?'Updating...':'Saving...'}}
          </ng-container>
          <ng-container *ngIf="inProgress?.value!='true'">
            <i class="bx bx-save"></i>{{u?.value?.id?'Save Changes':'Save'}}
          </ng-container>
        </button>
      </div>
    </div>
  </div>
</form>
<form [formGroup]="desiginationForm" (ngSubmit)="saveDesigination(isUpserting)" *ngIf="u.value.id">
  <div class=" modal-header">
    <h5 class="modal-title d-flex align-items-center">
      <i class="bx bx-home-circle me-1 font-20 text-primary"></i>{{desiginationForm?.value?.id?'Update':'Add'}}
      Designation
    </h5>
  </div>
  <div class="modal-body">
    <div class="row g-3">
      <div class="col-md-3" formGroupName="title">
        <label for="type" class="form-label">Title<b class="text-secondary">*</b></label>
        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0"><i class='bx bxs-grid-alt'></i></span>
          <ng-select class="form-control rcx-ng-select" formControlName="id" placeholder="Select title"
            [ngClass]="{'is-invalid': isTitleSubmitted && g.controls?.id?.errors}" [clearable]="false" [readonly]="f.id.value">
            <ng-option *ngFor="let title of titles;" [value]="title?.id">{{title?.name}}</ng-option>
          </ng-select>
          <div class="invalid-feedback" *ngIf="isTitleSubmitted && g.controls?.id?.errors">
            <span *ngIf="g.controls.id?.errors.required">Please select a title.</span>
            <span *ngIf="g.controls.id?.errors.pattern">Only letters are allowed.</span>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <label for="date" class="form-label">Start Date<b class="text-secondary">*</b></label>
        <div class="input-group"> <span class="input-group-text bg-transparent  border-end-0"><i
              class='bx bx-calendar'></i></span>
          <input type="date" class="form-control ps-1" id="date" formControlName="start" [readonly]="f.id.value"
            [max]="desiginationForm?.value?.end" [ngClass]="{'is-invalid': isTitleSubmitted && f.start.errors}" />
          <div class="invalid-feedback" *ngIf="isTitleSubmitted && f.start.errors">
            <span *ngIf="f.start.errors.required">Please select a start Date.</span>
          </div>
        </div>
      </div>
      <div class="col-md-{{f.id.value?'6':'4'}}">
        <label for="label" class="form-label">Remarks</label>
        <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i              class='bx bxs-comment'></i></span>
          <input type="text" class="form-control ps-1" id="label" placeholder="Enter designation remarks"
            [readonly]="f.id.value" [ngClass]="{'is-invalid': isTitleSubmitted && f.label?.errors}" formControlName="label"
            autocomplete="off" />
          <div class="invalid-feedback" *ngIf="isTitleSubmitted && f.label?.errors">
            <span *ngIf="f.label?.errors.required">Please enter a valid designation remarks..</span>
            <span *ngIf="f.label?.errors.pattern">Only letters are allowed.</span>
          </div>
        </div>
      </div>
      <div class="col-lg-auto ms-auto" #isUpserting>
        <button type="submit" class="btn btn-secondary rcx-btn" *ngIf="!f.id.value"
          [ngClass]="{'no-event':isUpserting?.value=='true'}" [disabled]="f.id.value">
          <ng-container *ngIf="isUpserting?.value=='true'">
            <span class="spinner-border-sm" role="status" aria-hidden="true"></span>
            {{desiginationForm?.value.id?'Updating...':'Saving...'}}
          </ng-container>
          <ng-container *ngIf="isUpserting?.value!='true'">
            <i class="bx bx-save"></i>{{desiginationForm?.value?.id?'Save Changes':'Save'}}
          </ng-container>
        </button>
      </div>
    </div>
  </div>
</form>
<div *ngIf="u.value.id">
  <app-address [refId]="u?.value?.id" ref="EMPLOYEE" [onLoad]="onLoad"></app-address>
</div>
